import { call, put, takeLatest, fork } from 'redux-saga/effects';
import * as http from 'utils/http';
import _ from 'lodash';
import { createJourneyLog } from 'redux/modules/log/effects';

import { setSubmiting } from './duck';

import { handleCostQuote } from './cost-quote';

import { logChangesGenerator } from 'redux/modules/log/log-changes';

const submitEditForm$ = 'journey-edit/submitEditForm$';
export const formChange$ = 'journey-edit/formChange$';

export const submitForm = (journey, { initialJourney, onSave }) => ({
  type: submitEditForm$,
  payload: {
    journey,
    onSave,
    initialJourney,
  },
});

export const formChange = (form) => ({
  type: formChange$,
  payload: form,
});

const getExtra = (target, type, concept) => {
  return target[type].find((extra) => extra.concept === concept) || {};
};

const hasExtraChange = ({ initialJourney, journey }, concept) => {
  const initialCost = getExtra(initialJourney, 'extra_costs', concept);
  const cost = getExtra(journey, 'extra_costs', concept);

  const constChange = String(initialCost.amount) !== String(cost.amount);

  return constChange;
};

function* handleLog({ journey, initialJourney }) {
  if (hasExtraChange({ initialJourney, journey }, 'COST_INCREMENT')) {
    const action = 'UPDATE_COST_INCREMENT';
    const changes = logChangesGenerator.get(action, {
      net_full_cost_before: _.get(initialJourney, 'net_full_cost'),
      net_full_cost_after: _.get(journey, 'net_full_cost'),
      currency_before: _.get(initialJourney, 'currency'),
      currency_after: _.get(journey, 'currency'),
    });
    yield put(
      createJourneyLog({
        action,
        journeyId: journey.id,
        editableAfterCreation: true,
        changes,
      })
    );
  }
  if (hasExtraChange({ initialJourney, journey }, 'BONUS')) {
    const action = 'UPDATE_BONUS';
    const changes = logChangesGenerator.get(action, {
      net_full_cost_before: _.get(initialJourney, 'net_full_cost'),
      net_full_cost_after: _.get(journey, 'net_full_cost'),
      currency_before: _.get(initialJourney, 'currency'),
      currency_after: _.get(journey, 'currency'),
    });
    yield put(
      createJourneyLog({
        action,
        journeyId: journey.id,
        changes,
      })
    );
  }
  if (hasExtraChange({ initialJourney, journey }, 'PENALTY')) {
    const action = 'UPDATE_PENALTY';
    const changes = logChangesGenerator.get(action, {
      net_full_cost_before: _.get(initialJourney, 'net_full_cost'),
      net_full_cost_after: _.get(journey, 'net_full_cost'),
      currency_before: _.get(initialJourney, 'currency'),
      currency_after: _.get(journey, 'currency'),
    });
    yield put(
      createJourneyLog({
        action,
        journeyId: journey.id,
        editableAfterCreation: true,
        changes,
      })
    );
  }
}

function* handleEditSubmit({ payload }) {
  const { journey, initialJourney, onSave } = payload;
  const { extra_costs } = journey;
  try {
    yield put(setSubmiting(true));
    const newJourney = yield call(http.patch, journey.url, { extra_costs });
    yield fork(handleLog, { journey: newJourney, initialJourney });
    yield call(onSave, newJourney);
  } catch (err) {
    yield call(http.getError, err);
  } finally {
    yield put(setSubmiting(false));
  }
}

export function* watchJourneyEdit() {
  yield takeLatest(submitEditForm$, handleEditSubmit);
  yield takeLatest(formChange$, handleCostQuote);
}
